import React from "react";
import Button from "../../../../../../components/shared/Button/Button";

export function SuggestionRail({ onClick, suggestions = [] }) {
  if (!suggestions?.length) return null;

  return (
    <>
      {suggestions.map((s) => (
        <Button
          className="btn-shadow-purple-2 border-grayTrue600 border text-sm text-white"
          color="grayTrue700"
          key={s}
          onClick={() => onClick(s)}
          rounded="md"
          size="sm"
        >
          {s}
        </Button>
      ))}
    </>
  );
}
